import React from 'react';
import styled from 'styled-components';
import ChannelTooltip from '../../components/Channels/tooltip';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';

const Wrapper = styled.div`
    display: block;
    width: 100%;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    padding-top: 30px;
    @media (max-width: 640px) {
        padding-top: 20px;
    }
`;
const ThemeName = styled.div`
    font-size: 20px;
    line-height: 1.4em;
`;
const GreyChannelsCount = styled.div`
    color: ${COLORS.darkGrey};
`;
const Channels = styled.div`
    margin-top: 20px;
    @media (max-width: 640px) { 
        justify-content: space-between;
    }
`;

const channelsText = declOfNum(['канал', 'канала', 'каналов']);

const ThemedChannels = ({ theme }) => {
    const { id, name, channels = [] } = theme;
    const count = channels.length;
    if (count === 0) {
        return null;
    }
    let countHD = 0;
    const logos = channels.map(channel => {
        countHD += +channel.isHd;
        return <ChannelTooltip key={channel.id} channel={channel} />;
    });
    const title = count + (countHD ? ` (${countHD} HD) ` : ' ') + channelsText(count);
    return (
        <Wrapper id={`theme_${id}`} key={id}>
            <ThemeName data-test='name-theme'>{name}</ThemeName>
            <GreyChannelsCount data-test='count-channels'>{title}</GreyChannelsCount>
            <Channels data-test='channels-essence'>
                {logos}
            </Channels>
        </Wrapper>
    );
};

export default ThemedChannels;
